module.exports = __webpack_public_path__ + "img/LDJam41.dfd822b5.png";